import { TopWrapper } from "@components/collapsibleSection/CollapsibleSection.styles";
import styled from "styled-components";

import CollapsibleSection from "../../../components/collapsibleSection/CollapsibleSection";


export const CollapsibleSectionStyled = styled(CollapsibleSection)`
    ${TopWrapper} {
        margin-bottom: 0;
    }
`;

export const LegislativeExtraSalariesSmartFastEntryListStyled = styled.div`
    display: block;
    width: 100%;
`;